




































































































import {
  Component, Prop, Vue,
} from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import PerformanceWidgetRegionMarketSupply
  from '@/components/organisms/Performance/PerformanceWidgetRegion/PerformanceWidgetRegionMarketSupply/index.vue';
import PerformanceWidget from '@/components/organisms/Performance/PerformanceWidget/index.vue';
import PerformanceWidgetRegionAverageDailyRate
  from '@/components/organisms/Performance/PerformanceWidgetRegion/PerformanceWidgetRegionAverageDailyRate/index.vue';
import PerformanceWidgetRegionOccupancyRate
  from '@/components/organisms/Performance/PerformanceWidgetRegion/PerformanceWidgetRegionOccupancyRate/index.vue';
import PerformanceWidgetRegionBookings
  from '@/components/organisms/Performance/PerformanceWidgetRegion/PerformanceWidgetRegionBookings/index.vue';
import PerformanceWidgetRegionDayOfTheWeekOccupancy
  from '@/components/organisms/Performance/PerformanceWidgetRegion/PerformanceWidgetRegionDayOfTheWeekOccupancy/index.vue';
import AuthActionTypes from '@/modules/auth/AuthActionTypes';
import PerformanceWidgetRegionMap
  from '@/components/organisms/Performance/PerformanceWidgetRegion/PerformanceWidgetRegionMap/index.vue';
import PerformanceService from '@/modules/performance/services/PerformanceService';
import PerformanceWidgetRegionDayOfTheWeekPriceFactor
  from '@/components/organisms/Performance/PerformanceWidgetRegion/PerformanceWidgetRegionDayOfTheWeekPriceFactor/index.vue';
import PerformanceWidgetRegionMinNightStay
  from '@/components/organisms/Performance/PerformanceWidgetRegion/PerformanceWidgetRegionMinNightStay/index.vue';
import PerformanceWidgetRegionRentalType
  from '@/components/organisms/Performance/PerformanceWidgetRegion/PerformanceWidgetRegionRentalType/index.vue';
import PerformanceWidgetRegionOccupancyTrend
  from '@/components/organisms/Performance/PerformanceWidgetRegion/PerformanceWidgetRegionOccupancyTrend/index.vue';
import PerformanceWidgetRegionRentalSize
  from '@/components/organisms/Performance/PerformanceWidgetRegion/PerformanceWidgetRegionRentalSize/index.vue';
import MarketEstimatePotentialIncomeWidget
  from '@/components/organisms/MarketRegion/MarketEstimatePotentialIncomeWidget/index.vue';

@Component({
  name: 'PerformanceRegion',
  components: {
    PerformanceWidgetRegionMap,
    PerformanceWidget,
    PerformanceWidgetRegionMarketSupply,
    PerformanceWidgetRegionAverageDailyRate,
    PerformanceWidgetRegionOccupancyRate,
    PerformanceWidgetRegionBookings,
    PerformanceWidgetRegionDayOfTheWeekOccupancy,
    PerformanceWidgetRegionDayOfTheWeekPriceFactor,
    PerformanceWidgetRegionMinNightStay,
    PerformanceWidgetRegionRentalType,
    PerformanceWidgetRegionOccupancyTrend,
    PerformanceWidgetRegionRentalSize,
    MarketEstimatePotentialIncomeWidget,
  },
})
export default class PerformanceRegion extends Vue {
  protected widgetTypes: any = PerformanceService.WIDGET_TYPES;

  @Action(AuthActionTypes.SHOW_SIMPLE_AUTH_FORM, { namespace: 'auth' })
  protected dispatchShowSimpleAuthForm: any;

  @Getter('isAuthenticated', { namespace: 'auth' }) protected isAuthenticated!: boolean;

  @Prop() protected widgets: any;

  protected getWidget(type: string) {
    if (!this.widgets || !this.widgets[type]) {
      return {
        loading: true,
      };
    }
    return this.widgets[type];
  }

  protected onClickUnlock() {
    this.dispatchShowSimpleAuthForm({ isViewAccountPerformance: false });
  }
}
